import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function getSchemaFieldByName(fields: SchemaField[], name: string): SchemaField | undefined {
  return fields.find((field) => field.name === name)
}
